const { gql } = require("graphql.macro");
const queryRegions = gql`
  query queryRegions($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Regions", $language: String = "en") {
    obj: item(path: $itemPath, language: $language) {
      list: children {
        country: field(name: "Country") {
          ... on ReferenceField {
            fields: targetItem {
              key: field(name: "key") {
                value
              }
              phrase: field(name: "phrase") {
                value
              }
            }
          }
        }
        language: field(name: "language") {
          ... on MultilistField {
            count
            list: targetItems {
              key: field(name: "key") {
                value
              }
              phrase: field(name: "phrase") {
                value
              }
            }
          }
        }
      }
    }
  }
`;
export default queryRegions;
